export default __webpack_public_path__ + "static/media/Amanda.849f6c94.png";